import { render, staticRenderFns } from "./openVideoOnTime.vue?vue&type=template&id=ee564986&scoped=true&"
import script from "./openVideoOnTime.vue?vue&type=script&lang=js&"
export * from "./openVideoOnTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee564986",
  null
  
)

export default component.exports